import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcFavoriteFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.084 3A5.92 5.92 0 0 1 22 8.926c0 1.701-.78 3.125-1.76 4.213l-.002-.001c-.52.61-2.243 2.349-3.902 3.99-1.682 1.664-3.379 3.31-3.8 3.675a.81.81 0 0 1-1.061 0c-.422-.366-2.122-2.01-3.806-3.674-1.661-1.641-3.386-3.381-3.907-3.991C2.78 12.05 2 10.627 2 8.926A5.92 5.92 0 0 1 7.917 3c1.584 0 3.022.625 4.083 1.64A5.9 5.9 0 0 1 16.084 3"
  }));
}
var IcFavoriteFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcFavoriteFill));

export { IcFavoriteFill as I };
